import styled from '@emotion/styled';
import { IconButton, List, ListItem, ListItemText, Typography } from '@mui/material'
import React from 'react'
import { useTranslation } from 'react-i18next';
import { ProductMerchantModel } from '../../../models/productMerchant';
import DeleteIcon from '@mui/icons-material/Delete';
import { EN_ACCEPT_LANGUAGE } from '../../../constants/acceptLanguageApi';
import { numberFormat } from '../../../utils/nunberFormat';

interface Props {
    dataProductBySelect: ProductMerchantModel[]
    handleDeleteProduct: (id: string) => void
}

const ListSelectProductComponent = ({ dataProductBySelect, handleDeleteProduct }: Props) => {
    const { t, i18n } = useTranslation('global')
    const CustomListItem = styled(ListItem)({
        borderBottom: '1px solid #ddd',
        padding: '10px 0',
    });

    const CustomListItemTextPrimary = styled('span')({
        fontWeight: 'bold',
    });

    const CustomListItemTextSecondary = styled('span')({
        color: 'grey',
    });

    const totalPrice = dataProductBySelect?.reduce((acc, data) => {
        const itemPrice = data?.price?.price;
        return acc + itemPrice;
    }, 0);


    return (
        <>
            <List sx={{ width: '100%', bgcolor: 'background.paper' }}>
                {dataProductBySelect?.map((data: ProductMerchantModel, index: number) => (
                    <CustomListItem key={data?.id}>
                        <ListItemText
                            primary={
                                <>
                                    <CustomListItemTextPrimary>{index + 1}. {i18n.language === EN_ACCEPT_LANGUAGE ? data?.price?.masterProduct?.productNameEn : data?.price?.masterProduct?.productNameLa}</CustomListItemTextPrimary>
                                </>
                            }
                            secondary={
                                <>
                                    <CustomListItemTextSecondary>Quantity: 1 x {data?.price?.quantity}, Amount: {data?.price?.price} {data?.quantity && (<>,
                                        {t('promotion_page.total buy product')}{' '}
                                        <span style={{ color: 'red' }}>{data?.quantity}</span></>)}</CustomListItemTextSecondary>
                                </>
                            }
                        />
                        <IconButton edge="end" aria-label="delete" onClick={() => handleDeleteProduct(data.id)}>
                            <DeleteIcon />
                        </IconButton>
                    </CustomListItem>
                ))}
            </List>
            {
                dataProductBySelect?.length > 0 && <Typography variant="h6" sx={{ mt: 2 }}>
                    {t("promotion_page.Total amount")} : <span style={{ color: 'red' }}> {numberFormat(totalPrice)}</span> {t("Kip")}
                </Typography>
            }

        </>
    )
}

export default ListSelectProductComponent